export default "__VITE_ASSET__DcShGnEg__"